import { useEffect } from 'react';
import Lenis from 'lenis';

const SmoothScrolling = ({ children }) => {
  useEffect(() => {
    // Initialize Lenis for butter-smooth scrolling
    const lenis = new Lenis({
      duration: 1.6,  // Longer duration for butter smooth feel
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Custom easing
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
      normalizeWheel: true,
    });

    // Handle anchor links for smooth scrolling
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a');
      if (target && target.href && target.href.includes('#')) {
        const targetId = target.href.split('#')[1];
        const element = document.getElementById(targetId);
        
        if (element) {
          e.preventDefault();
          lenis.scrollTo(element, {
            duration: 2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
          });
        }
      }
    };

    // Add click listener for anchor links
    document.addEventListener('click', handleAnchorClick);

    // Animation frame for smooth scrolling
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Cleanup on unmount
    return () => {
      lenis.destroy();
      document.removeEventListener('click', handleAnchorClick);
    };
  }, []);

  return children;
};

export default SmoothScrolling;